export default __webpack_public_path__ + "static/media/caveat-v9-latin_cyrillic-regular.73981a29.ttf";